import { baseApi } from "./apiConfig.js";

export const submitContactUsForm = async (data) => {
  try {
    const response = await baseApi.post("/portal/save-contact-us-lead", data);
    return response.data;
  } catch (e) {
    console.log("error:", e);
  }
};

export const submitCommercialContactUsForm = async (data) => {
  try {
    const response = await baseApi.post("/portal/saveLead", {
      ...data,
      leadSource: "sell_commercial",
    });
    return response.data;
  } catch (e) {
    console.log("error:", e);
  }
};

export const submitBrokerContactUsForm = async (data) => {
  try {
    const response = await baseApi.post("/signatureseller/save-lead", {
      ...data,
      leadSource: "broker_program",
    });
    return response.data;
  } catch (e) {
    console.log("error:", e);
  }
};

export const submitPropertyTourRegistration = async ({ firstName, lastName, email, phone, propertyId, propertyAddress }) => {
  try {
    const response = await baseApi.post("/portal/notifications/property-tour/register", {
      firstName,
      lastName,
      email,
      phone,
      propertyId,
      propertyAddress,
    });
    return response.data;
  } catch (e) {
    console.log("error:", e);
    throw e;
  }
};
